import { forwardRef, createElement } from 'react';

function IconInboxSmart(props, svgRef) {
  return createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), createElement("path", {
    d: "M10 4v2H6.868l-2.723 7h3.202a1 1 0 01.916.598l.974 2.22a1 1 0 00.916.599h3.694a1 1 0 00.916-.598l.974-2.221a1 1 0 01.916-.598h3.201l-1.556-4h2.146l1.437 3.694c.079.202.119.417.119.634v4.922a1.75 1.75 0 01-1.606 1.744L20.25 20H3.75A1.75 1.75 0 012 18.25v-4.922c0-.217.04-.432.119-.634l2.947-7.578A1.75 1.75 0 016.697 4H10zm4 3.5a2 2 0 002 2 2 2 0 00-1.996 1.868L14 11.5a2 2 0 00-2-2 2 2 0 002-2zM17 2c0 2.21 2.015 4 4.5 4-2.386 0-4.338 1.65-4.49 3.737L17 10c0-2.21-2.015-4-4.5-4C14.985 6 17 4.21 17 2zM12.5.5A2.5 2.5 0 0015 3a2.5 2.5 0 00-2.495 2.336L12.5 5.5A2.5 2.5 0 0010 3 2.5 2.5 0 0012.5.5z",
    fill: "currentColor",
    fillRule: "evenodd"
  }));
}

var InboxSmart = /*#__PURE__*/forwardRef(IconInboxSmart);

export default InboxSmart;
//# sourceMappingURL=InboxSmart.js.map
